module.exports = __webpack_public_path__ + "img/about1.bcd79df8.png";